import React from 'react';
import { Card } from './ui';
import { Star, XCircle } from 'lucide-react';
export function Testimonials() {
  return <section className="py-10 bg-slate-900/50 border-y border-slate-800" data-id="element-38" data-mp="3mvbz6o9t1kbd">
      <div className="max-w-6xl mx-auto px-4" data-id="element-39" data-mp="38x5de6i4ras2">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-[22px] mb-[22px]" data-id="element-40" data-mp="38wce1qli3njy">
          <div data-id="element-41" data-mp="3dtvu8w1reaej">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-42" data-mp="3dxjmzszdqss7">✓</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-43" data-mp="2z59ewuc4tinb">Método paso a paso</p>
          </div>
          <div data-id="element-44" data-mp="33yu5407hh8by">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-45" data-mp="33zdnfi11pyqi">6</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-46" data-mp="2q7pbpfuplca2">Tomos completos</p>
          </div>
          <div data-id="element-47" data-mp="2u7zdegbgxgj4">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-48" data-mp="2u5d7el487930">5</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-49" data-mp="2g8gjosjem7qc">Bonos exclusivos</p>
          </div>
          <div data-id="element-50" data-mp="2l69opi8z0vp1">
            <p className="text-3xl font-bold text-white mb-1" data-id="element-51" data-mp="2l94bhgfgislm">⚡</p>
            <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-52" data-mp="2mninpfv1dypf">Acceso inmediato</p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-53" data-mp="2hrv1987xvjnm">
          <Card className="bg-slate-900" data-id="element-54" data-mp="2vps06b9v825g">
            <div className="flex gap-1 mb-4" data-id="element-55" data-mp="2vnfk63no41v1">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-56" data-mp="2qr89xyo8o47a" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-57" data-mp="22yi2a1ndc72t">
              "Antes me cansaba en dos cuadras. Hoy corrí mis primeros 5 km y no puedo creer lo que avancé."
            </p>
            <div className="flex items-center gap-3" data-id="element-58" data-mp="2cryux2brrg4w">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-59" data-mp="27zflmhk4775w">MG</div>
              <div data-id="element-60" data-mp="1k8s7vfnipnbf">
                <p className="font-bold text-white" data-id="element-61" data-mp="1k8a1vrb1zuqb">Martín G.</p>
                <p className="text-xs text-slate-500" data-id="element-62" data-mp="1faicp51smmpt">Córdoba</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-63" data-mp="3fczyeh947oid">
            <div className="flex gap-1 mb-4" data-id="element-64" data-mp="3kccmf5bq31mj">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-65" data-mp="3p3cm2ic87xsq" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-66" data-mp="3u2xgqgkd5jzn">
              "Pensaba que correr era imposible para mí. Este método me dio un camino claro para empezar sin frustrarme."
            </p>
            <div className="flex items-center gap-3" data-id="element-67" data-mp="31diae43n8fa2">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-68" data-mp="31e0axcxc9fns">LP</div>
              <div data-id="element-69" data-mp="3aegaibayo2nd">
                <p className="font-bold text-white" data-id="element-70" data-mp="3aeoraea7fs3u">Laura P.</p>
                <p className="text-xs text-slate-500" data-id="element-71" data-mp="3ac3nvku9d43z">Rosario</p>
              </div>
            </div>
          </Card>

          <Card className="bg-slate-900" data-id="element-72" data-mp="pnxqv2uv01f6">
            <div className="flex gap-1 mb-4" data-id="element-73" data-mp="pmwgl0lo3iyi">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-400 text-brand-400" data-id="element-74" data-mp="2a4yjcrbtzlk9" data-mpi={i} />)}
            </div>
            <p className="text-slate-300 italic mb-6" data-id="element-75" data-mp="2656fut1ao5lr">
              "Lo mejor fue entender cómo evitar lesiones desde el primer día. Ahora entreno con mucha más seguridad."
            </p>
            <div className="flex items-center gap-3" data-id="element-76" data-mp="1webvju7lzg2y">
              <div className="w-10 h-10 rounded-full bg-brand-900 flex items-center justify-center text-brand-400 font-bold" data-id="element-77" data-mp="1rfiiu405bt3u">RM</div>
              <div data-id="element-78" data-mp="1mfw39nwui0rv">
                <p className="font-bold text-white" data-id="element-79" data-mp="1mfcje1nmx2b7">Romina M.</p>
                <p className="text-xs text-slate-500" data-id="element-80" data-mp="1iealpp9d8ybc">Buenos Aires</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="py-12 px-4" data-id="element-81" data-mp="3cs22r9u0ykgt">
      <div className="max-w-3xl mx-auto" data-id="element-82" data-mp="3cr0o6vdsvfuc">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-83" data-mp="37th2jaerw0sd">
          ¿Cuántas veces más vas a volver a abandonar?
        </h2>

        <p className="text-slate-300 text-center text-[16px] mt-[11px] mb-[11px]" data-id="element-84" data-mp="24h06p8g9t1p1">
          Querés empezar a correr y sentirte mejor. Pero cada intento termina igual: te falta el aire, aparece una molestia y volvés a sentir que no es para vos.
        </p>

        <p className="text-lg font-bold text-center text-brand-400 mb-6" data-id="element-85" data-mp="20gg9y5zm003f">
          No es falta de voluntad. Es falta de un plan claro.
        </p>

        <Card className="bg-slate-900/80 border-red-900/30 mb-6" data-id="element-86" data-mp="1lqs7v2jlsxen">
          <ul className="space-y-3" data-id="element-87" data-mp="1qk3ep3of1e6k">
            {['Te ahogás a las dos cuadras y no sabés si es normal o si estás haciendo algo mal', 'Te duelen las rodillas, tobillos o espalda y te da miedo lesionarte', 'No sabés cuánto correr, cuándo descansar ni cómo progresar', 'Probás rutinas al azar y terminás abandonando otra vez', 'Gastás dinero en cosas que no necesitás sin ver resultados', 'No sabés qué zapatillas elegir para empezar de forma segura', 'Te falta motivación porque todavía no ves un camino posible'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-88" data-mp="y580zlakn43d" data-mpi={i}>
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-89" data-mp="y6j6pqnkulx4" />
                <span className="text-slate-300 text-lg" data-id="element-90" data-mp="t53p68klyxjh">{item}</span>
              </li>)}
          </ul>
        </Card>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-91" data-mp="173tidd4b4d2k">
          ¿Y si esta fuera la vez que sí llegás a tus 5 km?
        </h3>
      </div>
    </section>;
}